<header>
    <nav>
        <div class="container">
            <div class="d-flex justify-content-center lines">
                <a routerLink="/">
                    <div class="img-container">
                        <img src="./images/logo.png" alt="">
                    </div>
                </a>
            </div>
        </div>
    </nav>
</header>